import { render, staticRenderFns } from "./exportComponents.vue?vue&type=template&id=5fa7c6bc&scoped=true"
import script from "./exportComponents.vue?vue&type=script&lang=js"
export * from "./exportComponents.vue?vue&type=script&lang=js"
import style0 from "./exportComponents.vue?vue&type=style&index=0&id=5fa7c6bc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa7c6bc",
  null
  
)

export default component.exports